import { DefaultService } from '@/services/DefaultService';

export default class AgroFenologiaItemService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(form) {
		return this._http.post(`${this._env}/agro/fenologiaitem`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  findAll(uuid, column, order, page, limit, ...params) {
    return this._http.get( encodeURI(`${this._env}/agro/fenologiaitem.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}&uuid=${uuid}`), this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
    });
}
}